interface EmptyStateProps {
  title: string;
  description: string;
  icon?: string;
}

export function EmptyState({ title, description, icon = '📭' }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <span style={{ fontSize: '3rem' }}>{icon}</span>
      <h3 style={{ fontSize: '1.125rem', fontWeight: 600, color: 'var(--fg)' }}>{title}</h3>
      <p style={{ maxWidth: '280px' }}>{description}</p>
    </div>
  );
}